import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ManageEntitiesDialog from '@/views/agents/components/manage-dialog/manageEntitiesDialog.vue';
import { useBuildGroupsProvider } from '@/views/agents/components/buildGroups/buildGroups.helpers';
import { ref } from 'vue';
import BuildGroupsTable from '@/views/agents/components/buildGroups/buildGroupsTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'manageBuildGroupsDialog',
  setup(__props) {

const { searchInputVal, sort, buildGroupListFiltered, addNewBuildGroupRow } = useBuildGroupsProvider();
const handleSortChange = (newTableSort: { name: string; descending: boolean }) => {
  sort.value = newTableSort;
};
const keepShowError = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ManageEntitiesDialog, {
    modelValue: _unref(searchInputVal),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchInputVal) ? (searchInputVal).value = $event : null)),
    "add-entity": _unref(addNewBuildGroupRow),
    "dialog-title": "Manage Build Groups",
    "dialog-name": "manageBuildGroupsDialog",
    "add-entity-button-title": "Add Build Group"
  }, {
    "table-slot": _withCtx(({ isClosed }) => [
      _createVNode(BuildGroupsTable, {
        "build-groups": _unref(buildGroupListFiltered),
        "is-closed": isClosed,
        onUpdateTableSort: _cache[0] || (_cache[0] = val => handleSortChange(val)),
        onKeepShowError: _cache[1] || (_cache[1] = val => (keepShowError.value = val))
      }, null, 8, ["build-groups", "is-closed"])
    ]),
    _: 1
  }, 8, ["modelValue", "add-entity"]))
}
}

})